import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Navbar from "src/components/Landing/Navbar";
import DialogInfoGeneral from "src/components/Shared/DialogInfoGeneral";
import APIService from "src/services/Api";
import Footer from "src/components/Landing/Footer";
import Notify from "src/toast/Notify";
import { ImSpinner9 } from "react-icons/im";
import { ToastContainer } from "react-toastify";
import { VideoPromotionalSection } from "src/types";
import CustomVideoPlayer from "src/components/Shared/CustomVideoPlayer";
const PromotionalVideoWatch = () => {
  const params = useParams();
  const { videoslug } = params;
  const [codeText, setCodeText] = useState<string>();
  const [email, setEmail] = useState<string>();
  const [incorrectCode, setIncorrectCode] = useState<boolean>(false);
  const [timeExpired, setTimeExpired] = useState<any>();
  const [viewPopupCode, setViewPopupCode] = useState<boolean>(true);
  const [touchedForm, setTouchedForm] = useState<boolean>(false);
  const [section, setSection] = useState<VideoPromotionalSection>();
  const [loading, setLoading] = useState<boolean>(false);
  const toke = async () => {
    await APIService.getToken();
  };

  const checkEmail = () => {
    const patron = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (patron.test(email || "")) {
      return true; // El correo es válido
    } else {
      return false; // El correo no es válido
    }
  };

  const checkCodeEmpty = () => {
    if (!codeText?.length) {
      return false;
    }
    return true;
  };

  const handleCheckCode = async () => {
    setTouchedForm(true);
    if (checkEmail() && checkCodeEmpty()) {
      setLoading(true);
      const res = await APIService.getVideoPromotional({
        slug: videoslug,
        email,
        code: codeText,
      });
      if (res?.data?.status) {
        setViewPopupCode(false);
        const ahora = moment().tz("America/Bogota");

        // Calcular el tiempo de expiración (30 minutos)
        const tiempoExpiracion = 30 * 60 * 1000; // 30 minutos * 60 segundos/minuto * 1000 milisegundos/segundo

        // Crear el objeto Moment para el tiempo de expiración
        const fechaExpiracion = moment(ahora.valueOf() + tiempoExpiracion).tz(
          "America/Bogota"
        );
        setTimeExpired(fechaExpiracion);
        Notify("Acceso concedido");
        setSection(res?.data?.data?.section);
      } else {
        setIncorrectCode(true);
        Notify(res?.data?.message);
      }
      setLoading(false);
    }
  };

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      handleCheckCode();
    }
  };

  useEffect(() => {
    toke();
  }, []);

  const handleContextMenu = (e: any) => {
    e.preventDefault(); // Evita que se abra el menú contextual
  };

  return (
    <>
      <ToastContainer
        position="bottom-center"
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div
        className="bg-stone-50 pt-10 pb-40"
        onContextMenu={handleContextMenu}
      >
        <Navbar />
        <div className="mt-10"></div>
        <DialogInfoGeneral
          show={viewPopupCode}
          closeDialog={() => setViewPopupCode(false)}
          disabledFooter={true}
          disabledClosable={true}
        >
          <div className="p-6 opensans ">
            <div>
              <h3 className="fadeintop text-2xl mb-8">
                ✨ Video exclusivo ✨
              </h3>
              <div className="text-lg fadeinbottom mb-4">
                Para ver acceder al contenido, introduce el código a
                continuación:
              </div>
              {incorrectCode && (
                <div className="text-red-400 font-bold border border-red-400 px-2 py-1 w-fit rounded-md my-4 fadein">
                  Acceso denegado.
                </div>
              )}
              <div className="mt-2 fadein">
                <label htmlFor="codeid" className="text-base font-medium">
                  Introduce el código aquí
                </label>
                <div className="w-full">
                  <input
                    onChange={(e) => setCodeText(e.currentTarget.value)}
                    onKeyDown={handleKeyDown}
                    type="text"
                    id="codeid"
                    disabled={loading}
                    placeholder="Escribir..."
                    autoFocus
                    className="border border-stone-300 w-64 rounded-md px-2 py-2 bg-white shadow-md text-base"
                  />
                </div>
                {touchedForm && !checkCodeEmpty() && (
                  <div className="border border-red-400 text-red-400 w-fit rounded-md my-2 px-4 py-2 ronded-md text-xs">
                    El código es requerido.
                  </div>
                )}
                <div className="mt-4">
                  <label htmlFor="emailid" className="text-base font-medium">
                    Correo electrónico
                  </label>
                </div>
                <div className="w-64">
                  <input
                    onChange={(e) => setEmail(e.currentTarget.value)}
                    onKeyDown={handleKeyDown}
                    type="text"
                    id="emailid"
                    disabled={loading}
                    placeholder="Escribir..."
                    autoFocus
                    className="border border-stone-300 w-full rounded-md px-2 py-2 bg-white shadow-md text-base"
                  />
                </div>

                {touchedForm && !checkEmail() && (
                  <div className="border border-red-400 text-red-400 w-fit rounded-md my-2 px-4 py-2 ronded-md text-xs">
                    Debe ingresar un correo electrónico valido
                  </div>
                )}

                {!loading ? (
                  <button
                    onClick={() => handleCheckCode()}
                    className="mt-4 px-4 text-xl py-1 bg-yellow-400 font-semibold rounded-md"
                  >
                    Continuar
                  </button>
                ) : (
                  <button className="mt-4 px-4 text-xl flex items-center gap-4 py-1 bg-yellow-400 font-semibold rounded-md">
                    Comprobando..{" "}
                    <ImSpinner9 className="animate-spin" size={18} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </DialogInfoGeneral>
        {section && (
          <div>
            <div className="w-full lg:w-9/12 px-2 xl:px-6 bg-white mx-auto border border-stone-200 rounded-md ">
              <div className="mt-10 text-lg font-semibold opensans bg-amber-400 w-fit rounded-md px-0.5 py-0.5">
                ⭐️ ¡Video exclusivo! ⭐️
              </div>
              <div className="bg-white px-2 py-1 text-xl rounded-md font-semibold opensans w-fit my-4">
                ✨ {section?.name} ✨
              </div>
              <div className="px-4 font-light text-xs text-stone-700 mb-2">
                Esta lección cuenta con {section?.videoPromotional?.length}{" "}
                video{section?.videoPromotional?.length !== 1 && "s"}
              </div>
              <div>
                {section?.videoPromotional
                 .sort((a, b) => moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf())
                ?.map((vp) => (
                  <div key={vp.id} className="px-2 md:px-10 border border-stone-300 rounded-md mb-6 shadow-md py-4">
                    <div className="text-base text-center rounded-md font-bold uppercase opensans w-fit mt-2">
                      {vp?.name}
                    </div>
                    <div className="w-full h-1 border-b border-stone-200 mb-2"></div>
                    <div className="text-sm text-center rounded-md font-normal opensans w-fit mb-4">
                      {vp?.description}
                    </div>
                    {vp?.videoUrl && timeExpired ? (
                      <div className="rounded-md my-video-class">
                        <CustomVideoPlayer videoUrl={`${process.env.REACT_APP_API}/v1/system/video-watch-secure/${vp?.id}/${timeExpired}}`}                    
                         />

                      </div>
                    ) : (
                      <div>
                        <img
                          alt={"iniciar video"}
                          className="md:w-1/2 mx-auto"
                        />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};
export default PromotionalVideoWatch;
